// extracted by mini-css-extract-plugin
export var formContainer = "_cv-0";
export var message = "_cv-1";